module.exports = __webpack_public_path__ + "media/images/svgs/person-icon-de7fb44a7b8a91481fdc4e4682c2ae08.svg";